var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    ref: "chargingStationForm",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-container', [_c('v-text-field', {
    attrs: {
      "loading": _vm.isLoading,
      "label": _vm.$t('report.thgChargingStation.title'),
      "outlined": "",
      "disabled": "",
      "data-test-form-charging-station-name": ""
    },
    model: {
      value: _vm.chargingStationName,
      callback: function callback($$v) {
        _vm.chargingStationName = $$v;
      },
      expression: "chargingStationName"
    }
  }), _c('v-menu', {
    ref: "menuStart",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": _vm.$t('components.thg.ThgMeterReadingForm.startDate'),
            "rules": _vm.dateRule,
            "required": "",
            "outlined": "",
            "data-test-form-start-date": ""
          },
          model: {
            value: _vm.meterReading.meterReading.startDate,
            callback: function callback($$v) {
              _vm.$set(_vm.meterReading.meterReading, "startDate", $$v);
            },
            expression: "meterReading.meterReading.startDate"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.isDatepickerStartMenuActive,
      callback: function callback($$v) {
        _vm.isDatepickerStartMenuActive = $$v;
      },
      expression: "isDatepickerStartMenuActive"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "active-picker": _vm.activePicker,
      "max": new Date().toISOString().substr(0, 10),
      "min": _vm.currentYear
    },
    on: {
      "update:activePicker": function updateActivePicker($event) {
        _vm.activePicker = $event;
      },
      "update:active-picker": function updateActivePicker($event) {
        _vm.activePicker = $event;
      }
    },
    model: {
      value: _vm.meterReading.meterReading.startDate,
      callback: function callback($$v) {
        _vm.$set(_vm.meterReading.meterReading, "startDate", $$v);
      },
      expression: "meterReading.meterReading.startDate"
    }
  })], 1), _c('v-menu', {
    ref: "menuEnd",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
            attrs = _ref2.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": _vm.$t('components.thg.ThgMeterReadingForm.endDate'),
            "rules": _vm.dateRule,
            "required": "",
            "outlined": "",
            "data-test-form-end-date": ""
          },
          model: {
            value: _vm.meterReading.meterReading.endDate,
            callback: function callback($$v) {
              _vm.$set(_vm.meterReading.meterReading, "endDate", $$v);
            },
            expression: "meterReading.meterReading.endDate"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.isDatepickerEndMenuActive,
      callback: function callback($$v) {
        _vm.isDatepickerEndMenuActive = $$v;
      },
      expression: "isDatepickerEndMenuActive"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "active-picker": _vm.activePicker,
      "max": new Date().toISOString().substr(0, 10),
      "min": _vm.currentYear
    },
    on: {
      "update:activePicker": function updateActivePicker($event) {
        _vm.activePicker = $event;
      },
      "update:active-picker": function updateActivePicker($event) {
        _vm.activePicker = $event;
      }
    },
    model: {
      value: _vm.meterReading.meterReading.endDate,
      callback: function callback($$v) {
        _vm.$set(_vm.meterReading.meterReading, "endDate", $$v);
      },
      expression: "meterReading.meterReading.endDate"
    }
  })], 1), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgMeterReadingForm.amountInKwh'),
      "required": "",
      "outlined": "",
      "data-test-form-amount-in-kwh": "",
      "type": "number"
    },
    model: {
      value: _vm.meterReading.meterReading.amountInKwh,
      callback: function callback($$v) {
        _vm.$set(_vm.meterReading.meterReading, "amountInKwh", _vm._n($$v));
      },
      expression: "meterReading.meterReading.amountInKwh"
    }
  }), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid,
      "data-test-form-submit": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgMeterReadingForm.submit")) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }